import React from 'react';
import type { ToastProps } from './types';

export const Toast: React.FC<ToastProps> = ({ message, isVisible }) => (
  <div
    style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#333',
      color: 'white',
      padding: '10px 20px',
      borderRadius: '4px',
      opacity: isVisible ? 1 : 0,
      transition: 'opacity 0.3s ease',
      zIndex: 1000,
      pointerEvents: 'none',
    }}
  >
    {message}
  </div>
);
